const icons = {
  setting: "fa fa-cog",
  edit: "fa fa-pencil",
  add: "fa fa-plus-circle",
  infoCircle: "fa fa-info-circle",
  delete: "fa fa-trash",
  signIn: "fa fa-sign-in",
  user: "person-fill",
  dropdown: "fa fa-angle-down",
  eye: "fa fa-eye",
  key: "fa fa-lock",
  eyeSlash: "fa fa-eye-slash",
  keyOpen: "fa fa-unlock-alt",
  logs: "fa fa-file-text",
  chevron_left: "fa fa-chevron-left",
  chevron_right: "fa fa-chevron-right",
  chevron_down: "fa fa-chevron-down",
  chevron_up: "fa fa-chevron-up",
  upload: "fa fa-cloud-upload",
  download: "fa fa-download",
  close: "fa fa-close",
  paper_plan: "fa fa-paper-plane",
  check: "fa fa-check",
  exclamation_circle: "fa fa-exclamation-circle",
  comment: "fa fa-comment",
  doubleAngleDown: "fa fa-angle-double-down",
  doubleAngleUp: "fa fa-angle-double-up",
  searchPlus: "fa fa-search-plus",
  externalLink:"fa fa-external-link text-secondary",
  user_person: "fa fa-user",
  envelope: "fa fa-envelope",
  phone: "fa fa-phone",
  user_plus: "fa fa-user-plus",
  sign_in: "fa fa-sign-in",
  id_badge: "fa fa-id-badge",
  user_circle_o: "fa fa-user-circle-o",
  globe: "fa fa-globe",
  import: "fa fa-upload",
  export: "fa fa-download",
}

export default icons;
